<template>
  <div>
    <div class="marTML" style="background:#f4f4f4;">
      <div class="widM fntH4 bold padTS padBS" style="color:#2c2c2c;">액티비티 예약</div>
    </div>

    <div class="osResTbScrollWrap marTML NCAcmi_table widM">
      <div class="osResTbScroll osResTbBlock">
        <table class="osResTb05 txtC">
          <caption>
            액티비티 예약 날짜별 시간 일정 안내
          </caption>
          <colgroup>
            <col style="width:23%;">
            <col style="width:auto;">
            <col style="width:20%;">
            <col style="width:auto;">
            <col style="width:23%;">
          </colgroup>
          <thead>
            <tr>
              <th scope="col">Day 1</th>
              <th scope="col">Day 2</th>
              <th scope="col">Day 3</th>
              <th scope="col">Day 4</th>
              <th scope="col">Day 5</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowspan="3">체크인 &amp;<br> 오리엔테이션</td>
              <td colspan="3">선택 프로그램 진행</td>
              <td rowspan="2">호텔 액티비티 &amp; <br>쇼핑몰<br>비즈니스 미팅<br>체크아웃</td>
            </tr>
            <tr>
              <td colspan="3">
                1. 짚라인 액티비티<br>
                2. 래프팅 액티비티<br>
                3. 몬쨈 글램핑<br>
                4. 매땡 코끼리 캠프<br>
                5. 도이 인타논<br>
                6. 도이수텝 &amp; 올드시티<br>
                7. 반캉왓 민예마을 &amp; 왓우몽 사원<br>
                8. 마사지 &amp; 쇼핑몰 (*마사지: 만 15세 이상 참여 가능)<br>
                9. 호텔 휴식
              </td>
            </tr>
            <tr>
              <td>웰컴 디너</td> 
              <td>자유 석식</td> 
              <td>갈라 디너</td> 
              <td>호텔 석식</td> 
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="widM txtC marTML">
      <a @click="openActivityPopup" class="disIb fntH5 bold NCAcmi_arrow" style="background:#20893d; color:#fff;">
        액티비티 정보 안내 &nbsp;
        <img src="@/views/survey2/images/NCAcmi_arrow.png" alt="" style="max-width:10px; width:2%; vertical-align: baseline;">
      </a>
      <p class="fntE txtL marTSM padBS" style="color:#d91734;">* 액티비티별 잔여 인원은 제출 시간에 따라 차이가 있을 수 있습니다.</p>
      <p v-if="isVip" class="fntE txtL padBS"><b>FC VIP 액티비티 골프/스파 조당 6개, EDC 골프/스파 조당 4개, DIA 골프/스파 조당 2개</b> <br>데일리 액티비티는 골프/스파/액티비티 중 1회만 참여 가능합니다. <br>양도를 위해 복수 선택이 가능하나, 본인이 중복 선택으로 참여 시 액티비티 참여가 불가능 합니다.</p>
    </div>

    <hr style="border-top:1px solid #ddd; background:#f4f4f4; padding:5px 0;">

    <template v-for="(activity, sq_code, i) in activities">
      <SurveyActivityParticipant
        :key="`activity_${sq_code}`"
        :activity="activity"
        :is-first="i === 0"
      />
      <hr
        v-if="i < activityCount - 1"
        :key="`hr_${activity.sq_code}`"
        style="border-top:1px solid #ddd; background:#f4f4f4; padding:5px 0;">
    </template>
  </div>
</template>

<script>
import { CommonMethodMixin } from '../mixins'
import { SURVEY, ACTIVITY_QUESTIONS, TOGGLE_ACTIVITY_POPUP, IS_VIP } from '@/store/actions/survey'
import { mapGetters } from 'vuex'
import SurveyActivityParticipant from './SurveyActivityParticipant.vue'

export default {
  name: 'SurveyActivityList',
  mixins: [CommonMethodMixin],
  components: {
    SurveyActivityParticipant,
  },
  computed: {
    ...mapGetters(SURVEY, {
      activities: ACTIVITY_QUESTIONS,
      isVip: IS_VIP
    }),
    activityCount() {
      return Object.keys(this.activities).length;
    }
  },
  methods: {
    openActivityPopup() {
      this.$store.commit(`${SURVEY}/${TOGGLE_ACTIVITY_POPUP}`, true);
    }
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/survey2/components/SurveyActivityList.vue